<template>
  <div>
    <el-form
      ref="CateFrom"
      :model="cateMod"
      label-position="top"
      label-width="130px"
      size="mini"
      :rules="rules"
    >
      <el-form-item label="分类名称" prop="cateName">
        <el-input v-model="cateMod.cateName"></el-input>
      </el-form-item>
      <el-form-item label="分类状态" prop="cateState">
        <a-switch v-model:checked="cateMod.cateState" checked-children="启用" un-checked-children="禁用" />
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditCateComHandle('CateFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { CategoryEdit } from "@/api/category";
export default {
  props: {
    cateMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      rules: {
        cateName: [
          { required: true, message: "请输入分类名称", trigger: "change" },
          { required: true, message: "请输入分类名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    EditCateComHandle(formName) {
        var state = this.cateMod.cateState ? 0 : 1;
        this.$refs[formName].validate().then((valid) => {
          if (valid) {
            CategoryEdit(this.cateMod.id, this.cateMod.cateName, state).then((res) => {
              if (res.code == 0) {
                this.$message.success(res.msg);
                this.$emit("EditCateComHandle");
              }
              else {
                this.$message.error(res.msg);
              }
            })
          } else {
            return false;
          }
        }); 
    },
    CancleEdit() {
        this.$emit("CancleEdit");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>